import { defineMessages } from '@jutro/locale';

export default defineMessages({
    everything: {
        id: 'gateway.directives.ProducerCodeSelectDirective.ProducerCodeSelect.Everything',
        defaultMessage: 'Everything'
    },
    workStartedByMe: {
        id: 'gateway.directives.ProducerCodeSelectDirective.ProducerCodeSelect.Work started by me',
        defaultMessage: 'Work started by me'
    }
});
